export const IMAGE_STYLE_PROVIDER_OPTIONS = [
  { value: "gemini-nano", label: "Nano Banana 2", title: "gemini-3.1-flash-image-preview" },
  { value: "grok", label: "Grok", title: "grok xai grok" },
  { value: "flux", label: "Flux", title: "Flux-1.1 Pro" },
  { value: "gemini-pro-nano", label: "Nano Banana Pro", title: "gemini-3-pro-image-preview" },
  { value: "gpt-image", label: "GPT Image", title: "GPT Image 1.5" },
  // Imagen sağlayıcıları deprecate edildi: artık SEÇİLEMEZ (UI'da gizli). Kod ve
  // etiketler bilerek korunuyor — eski eğitimlerde bu provider ile kaydedilmiş
  // görsellerin label'ı çözülebilsin diye tam liste duruyor. Tekrar açmak için
  // ilgili satırlardaki `deprecated: true` bayrağını kaldırmak yeterli.
  { value: "imagen4", label: "Imagen 4", title: "imagen-4.0-generate", deprecated: true },
  {
    value: "imagen4-ultra",
    label: "Imagen 4 Ultra",
    title: "imagen-4.0-ultra-generate",
    deprecated: true,
  },
  {
    value: "imagen4-fast",
    label: "Imagen 4 Fast",
    title: "imagen-4.0-fast-generate",
    deprecated: true,
  },
];

// Seçilebilir (gizlenmemiş) sağlayıcılar. Provider SEÇİM listelerinde bunu kullan;
// label/lookup için tam IMAGE_STYLE_PROVIDER_OPTIONS'ı kullanmaya devam et.
export const VISIBLE_IMAGE_STYLE_PROVIDER_OPTIONS = IMAGE_STYLE_PROVIDER_OPTIONS.filter(
  (option) => !option.deprecated
);
